import Vue from 'vue';
import { isReplacement } from '@/shared/dom/utils/isReplacement';

Vue.use({
  install(Vue) {
    Vue.prototype.$isReplacement = isReplacement;
  },
});
